import MandatesService from "@/api/services/mandates";

const initialState = {};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isMandateActive: () => (mandate) => mandate?.status === "active",
    isMandateToSetup: () => (mandate) => mandate?.status === "to_setup",
  },
  mutations: {},
  actions: {
    async sendInvoiceMandateForm(_, { mandateSubjectType, mandateSubjectId, email }) {
      return await MandatesService.sendInvoiceMandateForm(mandateSubjectType, mandateSubjectId, email);
    },
    async sendNewLink(_, { mandateId }) {
      return await MandatesService.sendNewLink(mandateId);
    },
    async cancel(_, { mandateId }) {
      return await MandatesService.cancel(mandateId);
    },
  },
};
